<!-- 项目详细信息/需确认是否为已废弃页面 -->
<template>
  <div class="clientContent">
    <div class="clientForm">
      <el-form label-width="130px" :rules="rules" ref="clientFormRules" :model="clientInfo">
        <div class="flexStyle mainContent">
          <div>
            <upload-image :imageUrls.sync="clientInfo.companyLogo" />
            <el-button v-if="clientInfo.companyLogo" @click="deleteImg" style="margin-top: 10px"
              >删除图片</el-button
            >
          </div>
          <div class="right">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="公司名称：" prop="corporateName">
                  <el-autocomplete
                    class="inline-input"
                    v-model="clientInfo.corporateName"
                    @select="handleSelect"
                    :fetch-suggestions="querySearch"
                    :trigger-on-focus="false"
                    placeholder="请输入"
                    @input="inputChanged"
                  >
                    <!-- <template slot-scope="{ item }">
                      <div class="name">{{ item.companyFullName }}</div>
                    </template> -->
                  </el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="所属行业：">
                  <dic-cascader typeCode="004" :selectValue.sync="clientInfo.industrys" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="优先级别：" prop="priority">
                  <dic-select
                    :code.sync="clientInfo.priority"
                    type-code="009"
                    placeholder="请选择"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="总部地址：">
                  <CascaderArea
                    :country="clientInfo.companyCountry"
                    :province="clientInfo.companyProvince"
                    :city="clientInfo.companyCity"
                    @searchArae="searchArae"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="主要联系人：">
                  <el-input
                    class="small_input"
                    v-model="clientInfo.contacts"
                    placeholder="姓名"
                  ></el-input>
                  <el-input
                    class="small_input"
                    v-model="clientInfo.post"
                    placeholder="岗位"
                    style="margin-left: 10px"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="公司简介：">
              <el-input
                v-model="clientInfo.companyProfile"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 10 }"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="mainContent" style="margin-top: 20px">
          <title-bar title="职位信息"></title-bar>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="招聘职位：" prop="recruitmentPosition">
                <el-input class="large_input" v-model="clientInfo.recruitmentPosition"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="薪资范围：">
                <div class="flexStyle">
                  <el-input v-model="clientInfo.wages" style="width: 250px">
                    <el-select
                      v-model="clientInfo.isAnnual"
                      slot="prepend"
                      placeholder="请选择"
                      style="width: 100px"
                    >
                      <el-option label="年薪" :value="1" />
                      <el-option label="月薪" :value="0" />
                    </el-select>
                  </el-input>
                  <span class="spanStyle">~</span>
                  <el-input v-model="clientInfo.wagess" class="small_input" />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="职位类型：">
                <dic-select
                  :code.sync="clientInfo.positionType"
                  type-code="008"
                  placeholder="请选择"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工作地点：" prop="dutyStation">
                <el-input v-model="clientInfo.dutyStation" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="汇报对象：">
                <el-input class="large_input" v-model="clientInfo.reportingObject" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="职位描述：" prop="jobDescription">
            <el-input
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="clientInfo.jobDescription"
            />
          </el-form-item>
          <el-form-item label="所需技能：" prop="requiredSkills">
            <el-input
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="clientInfo.requiredSkills"
            />
          </el-form-item>
          <el-form-item label="核心要求：" prop="coreRequirements">
            <el-input
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="clientInfo.coreRequirements"
            />
          </el-form-item>
          <div
            class="inputStyle flexStyle"
            v-for="(item, index) in clientInfo.projectCenterUpdateS"
            :key="item.key"
          >
            <el-form-item
              label="项目顾问："
              :prop="'projectCenterUpdateS.' + index + '.projectLeader'"
              :rules="{
                required: true,
                message: '请输入项目顾问',
                trigger: 'blur'
              }"
            >
              <el-input class="small_input" v-model="item.projectLeader" />
            </el-form-item>
            <el-form-item
              label="联系方式："
              :prop="'projectCenterUpdateS.' + index + '.contactInformation'"
              :rules="{
                required: true,
                message: '请输入联系方式',
                trigger: 'blur'
              }"
            >
              <el-input class="small_input" v-model="item.contactInformation" />
            </el-form-item>
            <el-form-item label="目标企业：">
              <el-input class="small_input" v-model="item.targetEnterprise" />
              <span
                class="iconStyle el-icon-circle-plus-outline add"
                @click="addprojectLeaderListAdd"
                v-if="clientInfo.projectCenterUpdateS.length === index + 1"
                >添加</span
              >
              <span
                class="iconStyle el-icon-remove-outline"
                @click="removeprojectLeaderListAdd(index)"
                v-if="clientInfo.projectCenterUpdateS.length > 1"
                >删除</span
              >
            </el-form-item>
          </div>
          <el-form-item label="市场反馈：">
            <el-input
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="clientInfo.marketFeedback"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目评估：">
            <el-input
              style="width: 80%"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="clientInfo.projectEvaluation"
            ></el-input>
          </el-form-item>
          <el-form-item label="启动时间：">
            <el-date-picker
              v-model="clientInfo.startTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间：">
            <el-date-picker
              v-model="clientInfo.endTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="buttonStyle">
      <el-button class="saveButton" @click="save">保存</el-button>
      <el-button class="cancelButton" @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import CascaderArea from '@/components/CascaderArea.vue'
import DicCascader from '@/components/DicCascader.vue'
import UploadImage from '@/components/UploadImage.vue'
import {
  addProjectCenter,
  getAllCompany,
  getInfoByCompanyName,
  updateProjectCenter,
  getProjectCenterById,
  getCompanyNameList
} from '@/api/projectCenter'
import TitleBar from '@/components/TitleBar.vue'
import DicSelect from '@/components/DicSelect.vue'

export default {
  components: {
    UploadImage,
    CascaderArea,
    TitleBar,
    DicCascader,
    DicSelect
  },
  data() {
    return {
      options: ['计算机', '自动化', '人工智能', '建筑', '房地产'],
      cilentNature: ['民企', '国企', '上市公司', '外企', '合资', '政府', '事业单位', '其他'],
      cilentScale: [
        '1-49人',
        '50-99人',
        '100-499人',
        '500-999人',
        '1000-2000人',
        '2000-5000人',
        '5000-10000人',
        '10000人以上'
      ],
      cilentState: ['未合作', '合作中', '待续约'],
      //表单信息
      clientInfo: {
        companyLogo: '', // 公司logo
        corporateName: '', // 公司名称
        industrys: [], // 所属行业
        priority: '', // 优先级别
        companyCountry: '', // 所在国家
        companyProvince: '', // 所在省份
        companyCity: '', // 所在城市
        contacts: '', // 姓名
        post: '', //岗位
        isAnnual: '', // 薪资选择
        wages: '', // 工资一
        wagess: '', // 工资二
        companyProfile: '', // 公司简介
        recruitmentPosition: '', // 招聘职位
        salaryRange: '', // 薪资范围
        positionType: '', //职位类型
        dutyStation: '', //工作地点
        reportingObject: '', //汇报对象
        jobDescription: '', //职位描述
        requiredSkills: '', //所需技能
        coreRequirements: '', //核心要求
        marketFeedback: '', //市场反馈
        projectEvaluation: '', //项目评估
        startTime: '', //启动时间
        endTime: '', //结束时间
        projectCenterUpdateS: [
          {
            projectLeader: '', // 项目顾问
            contactInformation: '', // 联系方式
            targetEnterprise: '' // 目标企业
          }
        ]
      },
      list: {
        allCompany: [], // 所有企业
        companyInfo: {} // 企业信息
      },
      rules: {
        corporateName: [{ required: true, message: '请输入公司名称' }],
        recruitmentPosition: [{ required: true, message: '请输入招聘职位', trigger: 'blur' }],
        dutyStation: [{ required: true, message: '请输入工作地点', trigger: 'blur' }],
        jobDescription: [{ required: true, message: '请输入职位描述', trigger: 'blur' }],
        requiredSkills: [{ required: true, message: '请输入所需技能', trigger: 'blur' }],
        coreRequirements: [{ required: true, message: '请输入核心要求', trigger: 'blur' }],
        priority: [{ required: true, message: '请选择优先级别', trigger: 'change' }]
      },
      //查询获取到的企业名称列表
      enterpriseNameList: [
        {
          value: ''
        }
      ]
    }
  },
  computed: {
    type() {
      return Number(this.$route.query.type)
    },
    id() {
      return Number(this.$route.query.id)
    },
    searchInfo() {
      if (this.$route.query.searchInfo) {
        return JSON.parse(this.$route.query.searchInfo)
      } else {
        return null
      }
    }
  },
  created() {
    this.$store.commit('changeQueryInfo', this.searchInfo)

    if (this.type) {
      this.searchProjectCenterById()
    }
  },
  methods: {
    async searchProjectCenterById() {
      const { data: res } = await getProjectCenterById({ id: this.id })
      if (res.resultCode === 200) {
        Object.assign(this.clientInfo, res.data.projectCenterResult)
        this.clientInfo.projectCenterUpdateS = res.data.projectLeaderListResults
      }
    },
    // 选择企业名称
    async handleSelect(val) {
      const { data: res } = await getCompanyNameList({ name: val.value })
      if (res.resultCode == 200) {
        this.form.enterpriseName = res.data[0]
        this.enterpriseNameList = []
      }
    },
    async querySearch(str, cb) {
      if (str != '') {
        const { data: res } = await getCompanyNameList({ name: str })
        if (res.resultCode === 200) {
          res.data.forEach((item) => {
            this.enterpriseNameList.push({
              value: item
            })
          })
          cb(this.enterpriseNameList)
        } else {
          this.$message.error('查询失败！')
        }
      }
      // 调用 callback 返回建议列表的数据
      cb(this.enterpriseNameList)
    },
    //输入值变化时
    inputChanged(){
      this.enterpriseNameList = []
    },
    //   添加联系人
    addprojectLeaderListAdd() {
      this.clientInfo.projectCenterUpdateS.push({
        projectLeader: '', // 项目顾问
        contactInformation: '', // 联系方式
        targetEnterprise: '' // 目标企业
      })
    },
    // 国家地区
    searchArae(val) {
      this.clientInfo.companyCountry = val.country
      this.clientInfo.companyProvince = val.province
      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.clientInfo.companyCity = val.city
      }
    },
    //   删除联系人
    removeprojectLeaderListAdd(index) {
      this.clientInfo.projectCenterUpdateS.splice(index, 1)
    },
    // 保存
    save() {
      this.$refs.clientFormRules.validate(async (valid) => {
        if (valid) {
          const params = {
            projectCenterUpdate: this.clientInfo,
            projectCenterUpdateS: this.clientInfo.projectCenterUpdateS
          }
          let res
          if (this.type) {
            res = await updateProjectCenter(params)
          } else {
            res = await addProjectCenter(params)
          }
          if (res.data.resultCode === 200) {
            this.$message.success(`${this.type ? '编辑' : '新增'}成功`)
          }
          this.$router.go(-1)
        }
      })
    },
    // 返回
    cancel() {
      this.$router.go(-1)
    },
    // 删除图片
    deleteImg() {
      this.clientInfo.companyLogo = ''
    }
  }
}
</script>

<style scoped lang="less">
.mainContent {
  background-color: #fff;
  padding: 20px;
  .right {
    width: 80%;
  }
}
.flexStyle {
  display: flex;
}
.flexStyleCloum {
  display: flex;
  flex-direction: column;
}
.inputStyle {
  /deep/ .el-input {
    margin: 0 5px 5px 0;
  }
  .iconStyle {
    display: inline-block;
    font-size: 16px;
    vertical-align: middle;
    cursor: pointer;
    color: #17757a;
  }
  .add {
    margin-right: 6px;
  }
}
.buttonStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 0 10px 20px 10px;
}
/deep/ .saveButton {
  background-color: #17757a !important;
  color: #fff;
  padding: 10px 30px;
}
/deep/ .cancelButton {
  border-color: #17757a !important;
  color: #17757a;
  padding: 10px 30px;
}
/deep/ .el-button:focus,
.el-button:hover {
  background-color: #fff;
}
.bottom {
  height: 20px;
}
.spanStyle {
  display: inline-block;
  padding: 0 10px;
  color: #17757a;
}
.dropDownBox {
  /deep/ .el-input__inner {
    width: 300px;
  }
}
</style>
